import React from 'react';
import { motion } from 'framer-motion';

const ProgressIndicator = ({ steps, currentStep, onStepClick }) => {
  // Calculate progress percentage
  const progressPercentage = ((currentStep) / (steps.length - 1)) * 100;
  
  return (
    <div className="w-full">
      {/* Progress bar */}
      <div className="relative mb-6">
        <div className="overflow-hidden h-2 text-xs flex rounded bg-gray-200">
          <motion.div 
            className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-400"
            initial={{ width: '0%' }}
            animate={{ width: `${progressPercentage}%` }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          ></motion.div>
        </div>
        
        {/* Step indicators */}
        <div className="absolute top-0 left-0 w-full flex justify-between transform -translate-y-1/2">
          {steps.map((step, index) => (
            <div 
              key={step.id}
              className="relative"
              onClick={() => index <= currentStep && onStepClick(index)}
            >
              <motion.div
                className={`w-6 h-6 rounded-full flex items-center justify-center cursor-pointer ${
                  index < currentStep 
                    ? 'bg-yellow-400 border-2 border-yellow-400' 
                    : index === currentStep 
                      ? 'bg-white border-2 border-yellow-400' 
                      : 'bg-white border-2 border-gray-300'
                }`}
                initial={{ scale: 1 }}
                animate={{ 
                  scale: index === currentStep ? [1, 1.2, 1] : 1,
                  backgroundColor: index <= currentStep ? '#FBBF24' : '#FFFFFF'
                }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
              >
                {index < currentStep ? (
                  <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                  </svg>
                ) : (
                  <span className={`text-xs font-medium ${index === currentStep ? 'text-yellow-500' : 'text-gray-500'}`}>
                    {index + 1}
                  </span>
                )}
              </motion.div>
              
              {/* Step label */}
              <div className={`absolute top-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap text-xs font-medium ${
                index <= currentStep ? 'text-yellow-500' : 'text-gray-500'
              }`}>
                {step.title}
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Current step title */}
      <div className="text-center mt-8">
        <h2 className="text-xl font-bold text-gray-800">
          Step {currentStep + 1}: {steps[currentStep].title}
        </h2>
        <div className="text-sm text-gray-500 mt-1">
          {currentStep + 1} of {steps.length}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
